import { useContext } from "react";
import { IntlProvider } from 'react-intl';
import { Localizations } from 'helpers/Localizations';
import { localeManagerContext } from 'helpers/Locale';

interface IProps {
    children: React.ReactNode
}

let MyIntlProvider = ({ children }: IProps) => {
    let localeManager = useContext(localeManagerContext);

    return (
        <div>
            <IntlProvider
                defaultLocale="it-IT"
                locale={localeManager.currentLocale}
                messages={Localizations[localeManager.currentLocale]}
            >
                {children}
            </IntlProvider>
        </div>
    );
};

export default MyIntlProvider;